import React, { useEffect, useState } from "react";
import { getWorkTypeList } from "../../utils/Helpers/GetWorkTypes";
import { getWorkTypesBuilding } from "../../utils/Helpers/GetWorkTypesBuilding";

import Select from "react-select";

export default function WorkTypeFilter({
  onSelectWorkType,
  reset,
  borderTrue,
  ismultiple,
  preSelectedValues,
  isdisabled,
  placeholder,
  isBuildingFilter,
  no_used_cached
}) {

  
  const [selectedWorkType, setSelectedWorkType] = useState(
    ismultiple ? [] : ""
  );

  const [list, setList] = useState([]);

  useEffect(() => {
    if (!isBuildingFilter &&
      preSelectedValues?.highway &&
      Array.isArray(preSelectedValues.highway) &&
      list.length > 0 &&
      selectedWorkType.length === 0
    ) {
      const preSelectedOptions = list.filter((option) =>
        preSelectedValues.highway.includes(option.value)
      );

      setSelectedWorkType(
        ismultiple ? preSelectedOptions : preSelectedOptions[0] || ""
      );
    }
    else if (isBuildingFilter &&
      preSelectedValues?.building &&
      Array.isArray(preSelectedValues.building) &&
      list.length > 0 &&
      selectedWorkType.length === 0
    ) {
      const preSelectedOptions = list.filter((option) =>
        preSelectedValues.building.includes(option.value)
      );
      setSelectedWorkType(
        ismultiple ? preSelectedOptions : preSelectedOptions[0] || ""
      );
    }
  }, [list, preSelectedValues, ismultiple]);

  useEffect(() => {
    if (reset) {
      setSelectedWorkType(ismultiple ? [] : "");
    }
  }, [reset]);

  useEffect(() => {
    const loadData = async () => {
      if (!isBuildingFilter) {           // only run if false
        const data = await getWorkTypeList(no_used_cached);
        setList(data);
      }
      else if(isBuildingFilter) {           // only run if false
        const data = await getWorkTypesBuilding(no_used_cached);
        setList(data);
      }
    };

    loadData();
  }, []);

  const handleChange = (workType) => {
    setSelectedWorkType(workType);
    if (ismultiple) {
      onSelectWorkType(workType.map((option) => option.value));
    } else {
      onSelectWorkType(workType?.value || "");
    }
  };
  
  
  return (
    <Select
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderColor: "#9FAFCA",
          borderWidth: "3px",
          borderTop: !borderTrue && "none",
          borderLeft: !borderTrue && "none",
          borderRight: !borderTrue && "none",
          boxShadow: borderTrue && "none",
          "&:hover": {
            borderColor: "#2684FF",
          },
        }),
        dropdownIndicator: (provided, state) => ({
          ...provided,
          color: "#a71e1e",
        }),
        placeholder: (provided) => ({
          ...provided,
          color: "#6c757d",
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? "#9FAFCA" : "white",
          color: state.isSelected ? "white" : "black",
          "&:hover": {
            backgroundColor: "#9FAFCA",
            color: "white",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
          borderRadius: 0,
        }),
      }}
      options={list}
      value={selectedWorkType}
      onChange={handleChange}
      placeholder={placeholder ? placeholder : "WORK TYPE"}
      isMulti={ismultiple}
      isSearchable
      isDisabled={isdisabled}

    />
  );
}
